import sdk from '../services/company-sdk';
import appAuth from '../app-auth';

/*******************************************************************************
 * Initial state
 */
const initialState = {
    companies: [],
    companiesLoading: false,
    companiesLoaded: false,

    activeCompanyId: null,
    activeCompanyLoading: false,
    activeCompany: {
        id: '',
        name: '',
        countries: [],
        identifierList: []
    }
};

/*******************************************************************************
 * Non-async action types
 */
const SET_STATE = 'company/setState';

/*******************************************************************************
 * Reducer
 */
export default function companyReducer( state = initialState, action ) {
    switch ( action.type ) {
        case SET_STATE: {
            return {
                ...state,
                ...action.state
            };
        }

        default:
            return state;
    }
}

/*******************************************************************************
 * Action creators
 */
function setState( state ) {
    return {
        type: SET_STATE,
        state
    };
}

function loadCompanies() {
    return ( dispatch ) => {
        dispatch( setState( {
            companiesLoading: true
        } ) );

        return sdk.getCompanies()
            .then( ( companies ) => {
                dispatch( setState( {
                    companies: companies
                        .sort( ( a, b ) => a.name.localeCompare( b.name,
                            'en', { 'sensitivity': 'base' } ) ),
                    companiesLoaded: true,
                    companiesLoading: false
                } ) );

                return companies;
            } )
            .catch( ( err ) => {
                dispatch( setState( {
                    companies: [],
                    companiesLoaded: true,
                    companiesLoading: false
                } ) );

                return [];
            } );
    };
}

function loadCompany( companyId ) {
    return ( dispatch ) => {
        dispatch( setState( {
            activeCompanyLoading: true
        } ) );

        return sdk.getCompany( companyId )
            .then( ( company ) => {
                dispatch( setState( {
                    activeCompany: company,
                    activeCompanyLoading: false
                } ) );

                return company;
            } )
            .catch( ( err ) => {
                dispatch( setState( {
                    activeCompany: initialState.activeCompany,
                    companiesLoading: false
                } ) );

                return initialState.activeCompany;
            } );
    };
}

function unloadCompany() {
    return ( dispatch ) => {
        dispatch( setState( {
            activeCompany: initialState.activeCompany,
            companiesLoading: false
        } ) );
    };
}

function setCompany( companyId ) {
    return async( dispatch, getState ) => {
        if ( getState().company.activeCompanyId !== companyId ) {

            if ( companyId ) {

                await appAuth.delegate( companyId );
                dispatch( loadCompany( companyId ) );
                dispatch( setState( { activeCompanyId: companyId } ) );
            } else {
                dispatch( unloadCompany() );
            }
        }

        return Promise.resolve();
    };
}

export const actions = {
    loadCompanies,
    setCompany,
};
